import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';

export const templateTerminal = document.createElement('template');

templateTerminal.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <div id="start-session-container">
        <gz-title fontweight="500" fontsize="20" id="start-session-title">Start Session</gz-title>
        <gz-text fontsize="14" id="start-session-info-first-line">Start remote shell connection to investigate and take actions directly on the endpoint.</gz-text>
        <gz-text fontsize="14" id="start-session-info-second-line">To continue, enter the two factor authentication code provided by the Authentication app.</gz-text>

        <gz-form-field id='authentication-code' class='label-mw-250 hidden' label='Authentication code'>
          <gz-input gz-form-input placeholder='Enter code...'></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-tooltip id="start-session-button-tooltip" class="mt-6">
            <gz-button id="start-session-button" disabled >Start session</gz-button>
        </gz-tooltip>
        <gz-text fontSize="14" id="redirect-user-info" class="hidden mt-2"></gz-text>
    </div>
    <div id="terminal-container" class="hidden"></div>
    <div id="end-session-container" class="hidden">
        <gz-title fontweight="500" fontsize="20" id="end-session-title" class="mb-4">Session Ended</gz-title>
        <gz-text fontsize="14" id="end-session-info" class="mb-2">You can check out all the session details by downloading the activity log archive, or access them later in User Activity.</gz-text>

        <div class="end-session-time-content">
          <div class="label-box">
            <div id="session-start-time-label" class="label-text">
              <gz-title fontSize="12" fontWeight="400">
                <gz-tooltip tooltiptext="" isellipsis="true">
                  <span></span>
                </gz-tooltip>
              </gz-title>
            </div>
            <div id="session-end-time-label" class="label-text">
              <gz-title fontSize="12" fontWeight="400">
                <gz-tooltip tooltiptext="" isellipsis="true">
                  <span></span>
                </gz-tooltip>
              </gz-title>
            </div>
          </div>
          <div class="time-box">
            <gz-title fontSize="12" id="session-start-time-content"></gz-title>
            <gz-title fontSize="12" id="session-end-time-content"></gz-title>
          </div>
        </div>


        <div class="mt-4">
        <gz-button id="download-archive-button" class="mr-2"> Download audit log </gz-button>
          <gz-button id="restart-session-button" type="outline" color="secondary">Start new session</gz-button>
        </div>
    </div>
  </div>
`;
